const clamp=(v,min=0,max=1)=>Math.min(max,Math.max(min,v));
const ROOT='[data-ninja-scroll-video]';

function installGlobalBackground(root){
  let global=document.querySelector('.nsv-global-bg');
  if(global) return global;

  global=document.createElement('div');
  global.className='nsv-global-bg';
  global.setAttribute('aria-hidden','true');

  const layers=[
    root.querySelector('.nsv__media-bank'),
    root.querySelector('.nsv__grid'),
    root.querySelector('.nsv__shade'),
    ...root.querySelectorAll('.nsv__glow')
  ].filter(Boolean);

  layers.forEach(layer=>global.appendChild(layer));
  document.body.prepend(global);
  return global;
}

function initNinjaScroll(root){
  if(!root||root.dataset.nsvReady==='true') return;
  root.dataset.nsvReady='true';

  if(root.dataset.pageKey==='home') document.body.classList.add('nsv-home-active');

  const global=installGlobalBackground(root);
  const video=global.querySelector('.nsv__source-video');
  const atlas=global.querySelector('.nsv__source-atlas');
  const bar=root.querySelector('[data-nsv-progress]');
  const percentLabel=root.querySelector('[data-nsv-percent]');
  const stateLabel=root.querySelector('[data-nsv-state]');
  const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const docScroller=document.scrollingElement||document.documentElement;
  const pageWrapper=document.querySelector('.page-wrapper');
  let activeScroller=docScroller;

  const wrapperIsScrollable=()=>{
    if(!pageWrapper) return false;
    const style=getComputedStyle(pageWrapper);
    const overflowY=style.overflowY;
    return /(auto|scroll|overlay)/.test(overflowY) && pageWrapper.scrollHeight>pageWrapper.clientHeight+2;
  };

  const documentCanScroll=()=>docScroller.scrollHeight>window.innerHeight+2;

  if(wrapperIsScrollable() && (!documentCanScroll() || pageWrapper.scrollTop>0)){
    activeScroller=pageWrapper;
  }

  const getProgress=()=>{
    if(activeScroller===pageWrapper && pageWrapper){
      const max=Math.max(1,pageWrapper.scrollHeight-pageWrapper.clientHeight);
      return clamp(pageWrapper.scrollTop/max);
    }

    const top=window.scrollY||docScroller.scrollTop||document.body.scrollTop||0;
    const max=Math.max(1,docScroller.scrollHeight-window.innerHeight);
    return clamp(top/max);
  };

  const updateHud=value=>{
    const pct=Math.round(clamp(value)*100);
    if(bar) bar.style.height=`${pct}%`;
    if(percentLabel) percentLabel.textContent=`${String(pct).padStart(2,'0')}%`;
    if(stateLabel) stateLabel.textContent='SCROLL';
  };

  if(!video){
    if(atlas) root.classList.add('nsv--fallback');
    updateHud(getProgress());
    return;
  }

  root.classList.add('nsv--native');
  video.muted=true;
  video.playsInline=true;
  video.autoplay=false;
  video.loop=false;

  let duration=0;
  let destroyed=false;
  let raf=0;
  let lastProgress=-1;
  let pendingTime=null;
  let seekRaf=0;

  const refreshDuration=()=>{
    if(Number.isFinite(video.duration) && video.duration>0){
      duration=video.duration;
    }
  };

  const applySeek=()=>{
    seekRaf=0;
    if(destroyed||reducedMotion||duration<=0.05||pendingTime===null) return;

    const target=clamp(pendingTime,0,Math.max(0,duration-0.04));
    pendingTime=null;

    if(Math.abs(video.currentTime-target)<0.015) return;

    try{
      video.currentTime=target;
    }catch(_){ }
  };

  const seekToProgress=value=>{
    if(duration<=0.05) return;
    pendingTime=clamp(value)*Math.max(0,duration-0.04);
    if(!seekRaf) seekRaf=requestAnimationFrame(applySeek);
  };

  const render=()=>{
    raf=0;
    if(destroyed) return;

    const value=getProgress();
    updateHud(value);

    if(Math.abs(value-lastProgress)>0.0001){
      lastProgress=value;
      seekToProgress(value);
    }
  };

  const schedule=()=>{
    if(destroyed||raf) return;
    raf=requestAnimationFrame(render);
  };

  const onWindowScroll=()=>{
    activeScroller=docScroller;
    schedule();
  };

  const onWrapperScroll=()=>{
    activeScroller=pageWrapper;
    schedule();
  };

  const onMetadata=()=>{
    refreshDuration();
    video.pause();
    if(reducedMotion){
      try{video.currentTime=0;}catch(_){ }
      updateHud(0);
    }else{
      schedule();
    }
  };

  const onResize=()=>{
    if(wrapperIsScrollable() && (!documentCanScroll() || (pageWrapper && pageWrapper.scrollTop>0))){
      activeScroller=pageWrapper;
    }
    schedule();
  };

  video.addEventListener('loadedmetadata',onMetadata);
  video.addEventListener('durationchange',refreshDuration);
  video.addEventListener('canplay',schedule);
  window.addEventListener('scroll',onWindowScroll,{passive:true});
  window.addEventListener('resize',onResize,{passive:true});
  if(pageWrapper) pageWrapper.addEventListener('scroll',onWrapperScroll,{passive:true});

  refreshDuration();
  if(video.readyState===0){
    try{video.load();}catch(_){ }
  }
  schedule();

  root._nsvDestroy=()=>{
    destroyed=true;
    if(raf) cancelAnimationFrame(raf);
    if(seekRaf) cancelAnimationFrame(seekRaf);
    window.removeEventListener('scroll',onWindowScroll);
    window.removeEventListener('resize',onResize);
    if(pageWrapper) pageWrapper.removeEventListener('scroll',onWrapperScroll);
    video.removeEventListener('loadedmetadata',onMetadata);
    video.removeEventListener('durationchange',refreshDuration);
    video.removeEventListener('canplay',schedule);
    delete root._nsvDestroy;
  };
}

function initAll(scope=document){
  if(scope.matches?.(ROOT)) initNinjaScroll(scope);
  scope.querySelectorAll?.(ROOT).forEach(initNinjaScroll);
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',()=>initAll(),{once:true});
}else{
  initAll();
}

document.addEventListener('shopify:section:load',event=>initAll(event.target));
document.addEventListener('shopify:section:unload',event=>{
  const roots=[];
  if(event.target.matches?.(ROOT)) roots.push(event.target);
  event.target.querySelectorAll?.(ROOT).forEach(root=>roots.push(root));
  roots.forEach(root=>root._nsvDestroy?.());
});